/**
 * Configurazione e istanza di UserManager per autenticazione OIDC tramite AWS Cognito.
 * Fornisce anche la configurazione per react-oidc-context.
 */
import { WebStorageStateStore } from "oidc-client-ts";
import { UserManager } from "oidc-client-ts";
import type { AuthProviderProps } from "react-oidc-context";

/**
 * Istanza di UserManager configurata per autenticazione OIDC con Cognito User Pool.
 * - authority: endpoint OIDC Cognito
 * - client_id: client id registrato
 * - redirect_uri: callback dopo login
 * - post_logout_redirect_uri: callback dopo logout
 * - userStore: persistenza utente su localStorage
 * - response_type: tipo di risposta OIDC (code)
 * - scope: scope OIDC richiesti
 * - automaticSilentRenew: rinnovo automatico token
 */
export const userManager = new UserManager({
  authority: `https://cognito-idp.${
    import.meta.env.VITE_AUTH_USER_POOL_REGION
  }.amazonaws.com/${import.meta.env.VITE_AUTH_USER_POOL_ID}`,
  client_id: import.meta.env.VITE_AUTH_CLIENT_ID!,
  redirect_uri: window.location.origin + "/callback",
  post_logout_redirect_uri: window.location.origin + "/logged-out",
  userStore: new WebStorageStateStore({
    store: window.localStorage,
    prefix: import.meta.env.VITE_AUTH_CLIENT_ID,
  }),
  response_type: "code",
  scope: "email openid profile",
  automaticSilentRenew: true,
});

/**
 * Configurazione per il provider react-oidc-context.
 * Può essere usata direttamente come prop di AuthProvider.
 */
export const oidcConfig: AuthProviderProps = {
  userManager,
  // onSigninCallback: (userData) => {
  //   localStorage.setItem(
  //     "sessionId-" + userData?.profile.sub,
  //     Math.random().toString()
  //   );
  // },
};
